// Board Main Space Components
export { default as BoardMainSpace } from "./BoardMainSpace";
export { default as BoardMainSpaceLayout, LayoutItem } from "./BoardMainSpaceLayout";
export { BoardLoader } from "./BoardLoader";
export { BoardOverlay } from "./BoardOverlay";

// Re-export existing board components for easy access
export { ChannelsList } from "./ChannelsList";
export { EditableBoardName } from "./EditableBoardName";
export * from "./BoardEditActions";
export { EntityPills } from "./EntityPills";
export { UserProfile } from "./UserProfile";


// Modal exports
export { AddChannelModal } from "./modals/AddChannelModal";
export { BoardCurrencyModal } from "./modals/BoardCurrencyModal";
export { ChannelEntityModal } from "./modals/ChannelEntityModal";
export { BoardContentModal } from "./modals/BoardContentModal";
export { BoardSpecModal } from "./modals/BoardSpecModal";
export { FeatureExplanationModal } from "./modals/FeatureExplanationModal";
export { PageTypeSelectionModal } from "./modals/PageTypeSelectionModal";

// UI Components
export { BoardPagination } from "./BoardPagination";
export { BoardCurrencyButton } from "./BoardCurrencyButton";
export { BoardJournalList } from "./BoardJournalList";
export { BoardJournalDetails } from "./BoardJournalDetails";
export { StackedNoticeBanners, type Notice } from "./StackedNoticeBanners";
